import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueI18n from "vue-i18n";
// import i18n from './i18n.ts'
import "./registerServiceWorker";

// eslint-disable-next-line
import Login from "wl-vue-component-login";
// console.log("in main.js")
// console.log(Login)

// configure vue here
Vue.config.productionTip = false;
Vue.use(Login);
Vue.use(VueI18n);

// however, messages are defined by <i18n> tag in svc
const messages = {
  "de-sgd": {
    login: {
      test: "Erste Test Nachricht de"
    }
  }
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "de-ioc", // set locale
  fallbackLocale: "de-sgd",
  messages // set locale messages
});

// configure campus here // use /conf/webapp.conf ??
Vue.prototype.$institut = "IOC";

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
